import { useSyncExternalStore } from 'react';
import { type SupportedCurrencies } from 'dibs-currency-helpers/exports/currencies.ts';
import serverVars from 'server-vars';

type CurrencyState = {
    currency: SupportedCurrencies;
    showCurrency: boolean;
};

type Listener = () => void;

const initialState: CurrencyState = {
    currency: (serverVars.get('serverCurrency') as SupportedCurrencies) || 'USD',
    showCurrency: false,
};
const getInitialState = (): CurrencyState => initialState;

const listeners = new Set<Listener>();
const subscribe = (listener: Listener): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

let state: CurrencyState = getInitialState();
const getState = (): CurrencyState => state;

const setCurrency = (newCurrency: SupportedCurrencies): void => {
    const merged: CurrencyState = {
        currency: newCurrency || state.currency,
        showCurrency: true,
    };

    if (merged.currency === state.currency && merged.showCurrency === state.showCurrency) {
        return;
    }

    state = merged;
    listeners.forEach(listener => {
        listener();
    });
};

const useCurrencyStore = (): CurrencyState =>
    useSyncExternalStore(subscribe, getState, getInitialState);

export { useCurrencyStore, setCurrency };
